import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductTransferOwnershipDocument.Delete.IRequest;
type Response = Api.Core.ProductTransferOwnershipDocument.Delete.IResponse;
type Headers = Api.Core.ProductTransferOwnershipDocument.Delete.IHeaders;
const url = '/api/ProductManagement/ProductTransferOwnershipDocument/:productId/:documentId';
export default async function productTransferOwnershipDocumentDeleteApi(params: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
